module.exports = __webpack_public_path__ + "img/result-detail-communication-outright02.5c74bad7.svg";